import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { PipeModule } from 'src/app/pipes/pipe.module';
import { ReportsService } from 'src/app/services/reports.services';
import { ReportData } from 'src/models/reportData';
import { ChartComponent } from 'src/app/directives/chart/chart.component';

@Component({
  selector: 'app-profile-reports',
  templateUrl: './profile-reports.component.html',
  styleUrls: ['./profile-reports.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, PipeModule, ChartComponent]
})
export class ProfileReportsComponent implements OnInit, OnDestroy {
  @Input() profileId: number = 0;
  @Input() familyId: number = 0;
  @Input() serviceId: number = 0;
  @Input() reportId: number = 1010;

  titles: string[] = [];
  reportData: ReportData[] = [];
  subscriptions: Subscription[] = [];

  constructor(private reportService: ReportsService) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit() {
    this.subscriptions.push(this.reportService.getProfileReport(this.reportId, this.profileId, this.serviceId).subscribe(data => {
      if (data) {
        this.titles = [...new Set(data.map(d => d.Title))];
        this.reportData = data;
      }
    }));
  }
}
